/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Inspections_TaglineInputs */



/**
* | output |
* | --- |
* | "SIRE 2.0, pre-vetting, bulk carrier, barge, OVID and flag state inspections." |
*
* @param {Service_Inspections_TaglineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_inspections_tagline = /** @type {((inputs?: Service_Inspections_TaglineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Inspections_TaglineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("SIRE 2.0、预审查、散货船、驳船、OVID 及船旗国检查。")
	return /** @type {LocalizedString} */ ("SIRE 2.0, pre-vetting, bulk carrier, barge, OVID and flag state inspections.")
});